import React from "react";
import { Link } from "react-router-dom";
import styles from "./ContactSection.module.css";
import bubbleStyles from "../styles/Bubbles.module.css";

function ContactSection({ contact }) {
  const activeOperators =
    contact?.phoneOperators
      ?.filter((op) => !op.vacation)
      .sort((a, b) => a.order - b.order) || [];

  const vacationOperators =
    contact?.phoneOperators
      ?.filter((op) => op.vacation)
      .sort((a, b) => a.order - b.order) || [];

  return (
    <div className={styles.contactBox}>
      <div className={styles.contactNote}>
        <p>
          To schedule an appointment, please text the following number(s).{" "}
          <strong>
            <Link to="/register" className={styles.registerLink}>
              New users must register first.
            </Link>
          </strong>
        </p>
      </div>

      <div className={styles.contactDetails}>
        {/* ALL PHONE OPERATORS */}
        <div className={styles.phoneRow}>
          {activeOperators.map((op) => (
            <React.Fragment key={op.id}>
              <div
                className={`
                  ${bubbleStyles.bubbleStyle}
                  ${bubbleStyles.contactWrapper}
                  ${bubbleStyles.open}
                `}
              >
                <span className={styles.contactIcon}>📞</span>
                <span className={styles.contactName}>{op.name}:</span>
                <a
                  href={`tel:${op.phoneNumber}`}
                  className={styles.contactLink}
                >
                  {op.phoneNumber}
                </a>
              </div>

              {op.statusMessage && (
                <div className={styles.statusMessage}>
                  {op.name}: {op.statusMessage}
                </div>
              )}
            </React.Fragment>
          ))}

          {vacationOperators.length > 0 && (
            <hr className={styles.sectionLine} />
          )}

          {vacationOperators.map((op) => (
            <React.Fragment key={op.id}>
              <div
                className={`
                  ${bubbleStyles.bubbleStyle}
                  ${bubbleStyles.contactWrapper}
                  ${bubbleStyles.vacation}
                `}
              >
                <span className={styles.contactIcon}>📞</span>
                <span className={styles.contactName}>{op.name}:</span>
                <a
                  href={`tel:${op.phoneNumber}`}
                  className={styles.contactLink}
                >
                  {op.phoneNumber}
                </a>
                <span className={styles.vacationNote}>off</span>
              </div>

              {op.statusMessage && (
                <div className={styles.statusMessage}>{op.statusMessage}</div>
              )}
            </React.Fragment>
          ))}
        </div>
      </div>
    </div>
  );
}

export default ContactSection;
